export const lineSheetProductsUrl = {
  root: (
    agencyId: number,
    lineSheetSetId: number,
    lineSheetId: number,
    lineSheetTabIndex: number
  ) =>
    `/agencies/${agencyId}/line-sheet-sets/${lineSheetSetId}/line-sheets/${lineSheetId}/line-sheet-tabs/${lineSheetTabIndex}/products`,
};
